import(/* webpackMode: "eager" */ "/buggy-mccodeface-academy/app/global-error.tsx")